export default "__VITE_ASSET__f653fa59__"